import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import {
  fetchContacts,
  saveContact,
  updateContact,
  deleteContactById,
  sendInvitationToContact,
} from '../../store/actions/contacts';
import { getAllUserTypeRoles } from '../../store/actions/formOptions';
import { fetchPropertySuites } from '../../store/actions/suites';
import { selectSuites } from '../../store/selectors/suites';

import { selectProperties } from '../../store/selectors/properties';
import { selectContactFormData } from '../../store/selectors/contactForm';
import { selectFormOptions } from '../../store/selectors/formOptions';
import { selectContacts } from '../../store/selectors/contacts';
import ContactsTable from '../../components/ContactsTable';
import Heading from '../../components/Heading';
import Tabs from '../../components/Tabs';
import WithNavigation from '../../layouts/WithNavigation';
import { upload } from '../../helpers/upLoadHelper';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search';
import { resetUserPassword, activateUser } from '../../store/actions/auth';
import { selectLoader } from '../../store/selectors/loader';
import Loader from '../../components/Loader';
import { variables } from '../../Tenants';
import { stopLoaders } from '../../store/actions/loader';
import {
  clearActiveTab,
  clearActiveSuiteTab,
  clearActiveCatalogTab,
  clearActiveContactTab,
} from '../../store/actions/activeTab';

class Contacts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      selectedContacts: [],
    };
  }
  componentDidMount() {
    const {
      onFetchContacts,
      getAllUserTypeRoles,
      user,
      clearSearch,
      stopLoaders,
    } = this.props;
    stopLoaders();
    onFetchContacts(user.id, user.roles[0].role.name);
    getAllUserTypeRoles();
    clearSearch();
  }

  componentWillMount() {
    const {
      clearActiveTab,
      clearActiveSuiteTab,
      clearActiveCatalogTab,
      clearActiveContactTab,
    } = this.props;
    clearActiveTab();
    clearActiveSuiteTab();
    clearActiveCatalogTab();
    clearActiveContactTab();
  }

  // Todo: Refactor this so it's not being passed 3 layers down in the component tree pls.
  onSubmitContactForm = async (data) => {
    const { user } = this.props;
    let imageUrl = null;

    if (data.selectedImage && data.selectedImage.length > 0) {
      imageUrl = await upload(data.selectedImage[0]);
    }

    let assignedRoles = [];

    if (data.userRole) {
      for (var i = 0; i < this.props.formOptions.allRoles.length; i++) {
        if (data.userRole === this.props.formOptions.allRoles[i].name) {
          assignedRoles.push(this.props.formOptions.allRoles[i].id);
        }
      }
    }

    if (!data.userRole) {
      assignedRoles.push(data.roles[0].role.id);
    }

    let phone = data.phone;
    let cleaned = ('' + phone).replace(/\D/g, '');
    let formattedNumber = cleaned;

    if (cleaned.length === 10) {
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      formattedNumber = match[1] + '-' + match[2] + '-' + match[3];
    }

    let firstChar = data.firstname.charAt(0)?.toUpperCase();
    let slicedName = data.firstname.slice(1, data.firstname.length);
    let firstname = firstChar + slicedName;

    let PropertyId =
      data.userRole === 'Service Provider' || data.userRole === 'Vendor'
        ? null
        : data.propertyId
          ? data.propertyId
          : null;
    let SuiteId =
      data.userRole === 'Service Provider' || data.userRole === 'Vendor'
        ? null
        : data.suiteId
          ? data.suiteId
          : null;
    let ServicesProvided =
      data.userRole === 'Service Provider' || data.userRole === 'Vendor'
        ? data.servicesProvided
        : null;

    if (data.id) {
      let params = {
        id: data.id,
        username: data.username,
        email: data.email,
        firstname: firstname,
        lastname: data.lastname,
        phone: formattedNumber,
        profileImage: imageUrl != null ? imageUrl : data.profileImage,
        languages: null,
        customerId: null,
        deleted: false,
        assignedRoles: assignedRoles,
        address: data.address,
        UserId: user.id,
        SendActivationLink: data.sendActivationEmail
          ? data.sendActivationEmail
          : false,
        IsMultiSelect: true,
        RoleName: data.userRole,
        RoleId: assignedRoles[0],
        CompanyName: data.companyName,
        isDashboardAccess: data.isDashboardAccess,
      };

      if (data.userRole === 'Service Provider' || data.userRole === 'Vendor') {
        params.ServicesProvided = ServicesProvided;
      }

      if (data.userRole === 'Home Owner') {
        params.Suites = data.Suites.map((a) => ({
          Id: a.Id,
          PropertyId: a.propertyId,
        }));
        params.Properties = data.properties;
        params.isPrimaryContact =
          data && data.isPrimaryContact && data.isPrimaryContact === true
            ? true
            : false;
      }

      if (data.userRole === 'Realtor') {
        params.Suites = data.Suites.map((a) => ({
          Id: a.Id,
          PropertyId: a.propertyId,
        }));
        params.Properties = data.properties;
        params.isPrimaryContact =
          data && data.isPrimaryContact && data.isPrimaryContact === true
            ? true
            : false;
      }

      if (data.userRole === 'Occupant') {
        params.SuiteId = SuiteId;
        params.PropertyId = PropertyId;
        params.isPrimaryContact =
          data && data.isPrimaryContact && data.isPrimaryContact === true
            ? true
            : false;
      }

      if (
        data.userRole === 'Service Provider' ||
        data.userRole === 'Property Developer'
      ) {
        params.CalendarLink =
          data && data.calendarLink ? data.calendarLink.trim() : '';
        params.PersonalEmail =
          data && data.personalEmail ? data.personalEmail : '';
      }

      if (data.userRole === 'Service Manager') {
        params.PropertyId = PropertyId;
      }

      // You have to add it here.
      if (data.userRole === 'Service Provider') {
        params.ServiceProviderAssignedProperties =
          data.ServiceProviderAssignedProperties;
      }

      this.props.onUpdateContactForm(params);
    } else {
      let params = {
        username: data.email,
        email: data.email,
        firstname: firstname,
        lastname: data.lastname,
        phone: formattedNumber,
        profileImage: imageUrl,
        languages: null,
        customerId: null,
        SentEmail: true,
        assignedRoles: assignedRoles,
        address: data.address,
        UserId: user.id,
        SendActivationLink: data.sendActivationEmail
          ? data.sendActivationEmail
          : false,
        IsMultiSelect: true,
        RoleName: data.userRole,
        RoleId: assignedRoles[0],
        CompanyName: data.companyName,
        isDashboardAccess: data.isDashboardAccess
          ? data.isDashboardAccess
          : false,
      };

      if (data.userRole === 'Service Provider' || data.userRole === 'Vendor') {
        params.ServicesProvided = ServicesProvided;
      }

      if (data.userRole === 'Home Owner') {
        params.Suites = data.Suites.map((a) => ({
          Id: a.Id,
          PropertyId: a.propertyId,
        }));
        params.Properties = data.properties;
        params.Properties = data.properties;
        params.isPrimaryContact =
          data && data.isPrimaryContact && data.isPrimaryContact === true
            ? true
            : false;
      }

      // You have to add it here too omg.
      if (data.userRole === 'Service Provider') {
        params.ServiceProviderAssignedProperties =
          data.ServiceProviderAssignedProperties;
      }

      if (data.userRole === 'Realtor') {
        params.Suites = data.Suites.map((a) => ({
          Id: a.Id,
          PropertyId: a.propertyId,
        }));
        params.Properties = data.properties;
        params.isPrimaryContact =
          data && data.isPrimaryContact && data.isPrimaryContact === true
            ? true
            : false;
      }

      if (data.userRole === 'Occupant') {
        params.SuiteId = SuiteId;
        params.PropertyId = PropertyId;
        params.isPrimaryContact =
          data && data.isPrimaryContact && data.isPrimaryContact === true
            ? true
            : false;
      }

      if (data.userRole === 'Service Provider') {
        params.ServiceProviderAssignedProperties = data.properties;
      }

      if (
        data.userRole === 'Service Provider' ||
        data.userRole === 'Property Developer'
      ) {
        params.CalendarLink =
          data && data.calendarLink ? data.calendarLink.trim() : '';
        params.PersonalEmail =
          data && data.personalEmail ? data.personalEmail : '';
      }

      if (data.userRole === 'Service Manager') {
        params.PropertyId = PropertyId;
      }

      this.props.onSubmitContactForm(params);
    }
  };

  onDeleteContactById = (data) => {
    this.props.onDeleteContactById(data.id);
  };

  sendActivationLinkToUser = (data) => {
    this.props.activateUser(data, {
      UserId: data.id,
    });
  };

  sendResetPasswordLinkToUser = (data) => {
    this.props.resetUserPassword(data);
  };

  onSelectContact = (userId) => {
    let selectedContacts = this.state.selectedContacts;
    let index = selectedContacts.findIndex((sc) => sc.id === userId);
    if (index === -1) {
      selectedContacts = [...selectedContacts, { id: userId }];
    } else {
      selectedContacts = selectedContacts.filter((sc) => sc.id !== userId);
    }
    this.setState({ selectedContacts });
  };

  onSendInvitation = async () => {
    const { user, onSendInvitationToContacts } = this.props;
    let params = {
      userId: user.id,
      users: this.state.selectedContacts,
    };
    await onSendInvitationToContacts(params);
    this.setState({ selectedContacts: [] });
  };

  render() {
    const { contacts, setSearch, loader } = this.props;
    let propertyManagers = 0;
    let serviceProviders = 0;
    let homeOwners = 0;
    let realtors = 0;
    let vendors = 0;
    let strataManagers = 0;
    let occupants = 0;
    let serviceManagers = 0;
    if (contacts && contacts.length > 0) {
      contacts.map((data, i) => {
        let role =
          data && data.roles && data.roles.length > 0
            ? data.roles[0].role.name
            : '';
        if (role === 'Service Provider') {
          serviceProviders++;
        } else if (role === 'Property Developer') {
          propertyManagers++;
        } else if (role === 'Home Owner') {
          homeOwners++;
        } else if (role === 'Realtor') {
          realtors++;
        } else if (role === 'Vendor') {
          vendors++;
        } else if (role === 'Strata Manager') {
          strataManagers++;
        } else if (role === 'Occupant') {
          occupants++;
        } else if (role === 'Service Manager') {
          serviceManagers++;
        }
      });
    }

    return (
      <>
        {loader ? <Loader center={true} /> : null}
        <WithNavigation
          title="Contacts"
          top={
            <Heading
              headline="Contacts"
              items={[
                {
                  key: variables.propertyDevelopers,
                  value: propertyManagers,
                },
                {
                  key: 'Strata Managers',
                  value: strataManagers,
                },
                {
                  key: 'Service Providers',
                  value: serviceProviders,
                },
                {
                  key: variables.homeOwnerss,
                  value: homeOwners,
                },
                {
                  key: 'Realtor',
                  value: realtors,
                },
                {
                  key: 'Occupants',
                  value: occupants,
                },
                {
                  key: 'Vendors',
                  value: vendors,
                },
                {
                  key: 'Service Managers',
                  value: serviceManagers,
                },
              ]}
            />
          }
          bottom={
            <Tabs
              items={[
                {
                  label: 'Contacts',
                  length: contacts.length,
                  content: (
                    <ContactsTable
                      contacts={contacts}
                      onSubmitContactForm={this.onSubmitContactForm}
                      onDeleteContact={(data) => this.onDeleteContactById(data)}
                      sendResetPasswordLinkToUser={(data) =>
                        this.sendResetPasswordLinkToUser(data)
                      }
                      sendActivationLinkToUser={(data) =>
                        this.sendActivationLinkToUser(data)
                      }
                      properties={this.props.properties}
                      fetchPropertySuites={fetchPropertySuites}
                      fetchSuites={this.props.suites}
                      onSearch={(e) =>
                        setSearch({ contacts: e.target.value.trim() })
                      }
                      onSelectContact={this.onSelectContact}
                      selectedContacts={this.state.selectedContacts}
                      onSendInvitation={this.onSendInvitation}
                    />
                  ),
                },
              ]}
            />
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  contacts: selectContacts(state),
  properties: selectProperties(state),
  suites: selectSuites(state),
  contactFormData: selectContactFormData(state),
  formOptions: selectFormOptions(state),
  user: selectAuthenticatedUser(state),
  loader: selectLoader(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchContacts: fetchContacts,
      onSubmitContactForm: saveContact,
      onUpdateContactForm: updateContact,
      onDeleteContactById: deleteContactById,
      getAllUserTypeRoles,
      fetchPropertySuites,
      setSearch,
      clearSearch,
      resetUserPassword,
      activateUser,
      onSendInvitationToContacts: sendInvitationToContact,
      stopLoaders,
      clearActiveTab,
      clearActiveSuiteTab,
      clearActiveCatalogTab,
      clearActiveContactTab,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Contacts);
